import { render } from "./KidsCart.vue?vue&type=template&id=986d9af2&scoped=true"
import script from "./KidsCart.vue?vue&type=script&lang=js"
export * from "./KidsCart.vue?vue&type=script&lang=js"

import "./KidsCart.vue?vue&type=style&index=0&id=986d9af2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-986d9af2"]])

export default __exports__